export default "__VITE_ASSET__NRRL9XSM__"